import { Injectable } from '@angular/core';

declare let gtag:Function;

@Injectable({
  providedIn: 'root'
})


export class GoogleAnalyticsService {
  
  constructor() { 

}
public eventEmitter( 
  eventName: string, 
  eventCategory: string, 
  eventAction: string, 
  eventLabel: string = null,  
  eventValue: number = null ){ 
       gtag('event', 'Fin de la Solicitud', { 
        eventName:'Fin de la Solicitud',
               eventCategory: eventCategory, 
               eventLabel: eventLabel, 
                      eventValue: eventValue
             })
  }

}
